define.alias("shared/components/shared/color-picker/selector", "settings/components/shared/color-picker/selector");